 



// THIS CODE IS GENERATED.  CHANGES MADE TO THIS FILE WILL BE LOST.

import { Injectable } from '@angular/core';

import { ClientBase } from '../shared/core/ovs.core';
import { ResortBooking, BookingResult } from '../models/presentation.model';

export abstract class ResortBookingClientBase extends ClientBase
{
    public abstract Post(booking: ResortBooking,  success?: (value: BookingResult) => void, error?: (error: any) => void): void;
    public abstract Put(booking: ResortBooking,  success?: (value: BookingResult) => void, error?: (error: any) => void): void;
}

@Injectable()
export class ResortBookingClient extends ResortBookingClientBase
{
    public Post(booking: ResortBooking,  success?: (value: BookingResult) => void, error?: (error: any) => void): void
	{
        booking.BreakIt ="break it";
        this.basePost<BookingResult>("api/ResortBooking", BookingResult, booking, success, error);
	}
    public Put(booking: ResortBooking,  success?: (value: BookingResult) => void, error?: (error: any) => void): void
	{
        booking.BreakIt ="break it";
        this.basePut<BookingResult>("api/ResortBooking", BookingResult, booking, success, error);
	}
}







// WEBPACK FOOTER //
// /home/vsts/work/1/s/Ovs.Resort.UI.Web/src/app/services/resort-booking.client.ts